export const authPaths = {
    login: '/login',
    logout: '/logout',
    register: '/register',
    registerSuccess: '/register-success',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    verifyEmail: '/verify-email'
};